<div class="po-row po-mb-4 fundoLogo">
  <img alt="logo" class="po-navbar-logo-image " src="./assets/image/logo-solida.png">
</div>
<po-page-edit
  p-title="Atualização Cadastral - Cliente"
  [p-disable-submit]="validForm()"
  (p-save)="openModalConfirmar()"
>
  <form #formCadastroCliente="ngForm">
    <div class="po-row">
        <div class="po-lg-12">
            <h1 class="po-font-subtitle">Identificação</h1>
            <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="Código/Loja" [p-value]="clienteDto.cliente.CA1COD"></po-info>
            <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="CNPJ/CPF" [p-value]="utilService.formatarCGC(clienteDto.cliente.CA1CGC)"></po-info>
            <po-input
              class="po-md-4"
              name="CA1NOME"
              [(ngModel)]="clienteDto.cliente.CA1NOME"
              p-help="{{clienteOriginal.CA1NOME||'-'}}"
              p-label="Razão Social (*)"
              p-required

              [p-maxlength]="40"
              [p-minlength]="5">
            </po-input>
            <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="Inscrição Estadual" [p-value]="clienteDto.cliente.CA1INSCR"></po-info>
            <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="Inscrição Municipal" [p-value]="clienteDto.cliente.CA1INSCRM"></po-info>
          </div>
          <div class="po-lg-12">

            <h1 class="po-font-subtitle">Endereço</h1>
            <po-input
              class="po-md-2"
              name="CA1CEP"
              [(ngModel)]="clienteDto.cliente.CA1CEP"
              p-help="{{clienteOriginal.CA1CEP||'-'}}"
              p-label="CEP (*)"
              p-mask="99.999-999"
              p-required
              (p-change)="alteraCep()"
              [p-maxlength]="10"
              [p-minlength]="10">
            </po-input>
            <po-input
              class="po-md-6"
              name="CA1END"
              [(ngModel)]="clienteDto.cliente.CA1END"
              p-help="{{clienteOriginal.CA1END||'-'}}"
              p-label="Logradouro (*)"
              p-required
              [p-maxlength]="60"
              [p-minlength]="10">
            </po-input>
            <po-input
              class="po-md-3"
              name="CA1BAIRRO"
              [(ngModel)]="clienteDto.cliente.CA1BAIRRO"
              p-help="{{clienteOriginal.CA1BAIRRO||'-'}}"
              p-label="Bairro (*)"
              p-required
              [p-maxlength]="30"
              [p-minlength]="0">
            </po-input>
            <po-select
              class="po-md-3"
              name="CA1EST"
              [(ngModel)]="clienteDto.cliente.CA1EST"
              p-help="{{clienteOriginal.CA1EST||'-'}}"
              p-label="Estado (*)"
              [p-disabled]="true"
              [p-required]="true"
              [p-options]="listaEstado">
            </po-select>
            <po-lookup
              class="po-md-4"
              name="CA1COD_MUN"
              [(ngModel)]="clienteDto.cliente.CA1COD_MUN"
              p-help="{{clienteOriginal.CA1COD_MUN||'-'}}"
              p-field-label="CCC2MUN"
              p-field-value="CCC2CODMUN"
              p-label="Município IBGE (*)"
              [p-columns]="columnsMunicipioIBGEFilters"
              [p-field-format]="fieldFormaterMunicipioIBGEFilters"
              [p-filter-service]="municipioIBGEService"
              [p-advanced-filters]="advancedMunicipioIBGEFilters"
              [p-literals]="{ modalTitle: 'MunicipioIBGE' }"
              (p-selected)="municipioIBGESelecionado($event)">
            </po-lookup>
        </div>
        <div class="po-lg-12">
          <h1 class="po-font-subtitle">Contato</h1>
          <po-input
            class="po-md-2"
            name="CA1DDD"
            [(ngModel)]="clienteDto.cliente.CA1DDD"
            p-help="{{clienteOriginal.CA1DDD||'-'}}"
            p-label="DDD (*)"
            p-mask="999"
            p-required
            [p-maxlength]="3"
            [p-minlength]="2">
          </po-input>
          <po-input
            class="po-md-3"
            name="CA1TEL"
            [(ngModel)]="clienteDto.cliente.CA1TEL"
            p-help="{{clienteOriginal.CA1TEL||'-'}}"
            p-label="Telefone (*)"
            p-required
            [p-maxlength]="15"
            [p-minlength]="8">
          </po-input>
        </div>
        <div class="po-lg-12">
          <po-input
            class="po-md-3"
            name="CA1FAX"
            [(ngModel)]="clienteDto.cliente.CA1FAX"
            p-help="{{clienteOriginal.CA1FAX||'-'}}"
            p-label="FAX"
            [p-maxlength]="15"
            [p-minlength]="0">
          </po-input>
          <po-input
            class="po-md-4"
            p-icon="po-icon-mail"
            name="CA1EMAIL"
            [(ngModel)]="clienteDto.cliente.CA1EMAIL"
            p-help="{{clienteOriginal.CA1EMAIL||'-'}}"
            p-label="Email (*)"
            p-required
            p-placeholder="example@domain.com"
            [p-maxlength]="100"
            [p-minlength]="0">
          </po-input>
          <po-url
            class="po-md-4"
            name="CA1HPAGE"
            [(ngModel)]="clienteDto.cliente.CA1HPAGE"
            p-help="{{clienteOriginal.CA1HPAGE||'-'}}"
            p-label="Home Page"
            p-placeholder="www.domain.com"
            [p-maxlength]="30"
            [p-minlength]="0">
          </po-url>
        </div>
          <div class="po-row po-mt-2">
            <po-textarea class="po-md-12"
                         name="observacao"
                         [(ngModel)]="clienteDto.COBSERVACAO"
                         p-label="Observação:"
                         >
            </po-textarea>
        </div>
      </div>
    </form>
</po-page-edit>
